import { authorizedFetch } from "./base";
import { AppNotification } from "./types";

export async function getNotifications(): Promise<AppNotification[]> {
  return authorizedFetch<AppNotification[]>("/notifications");
}

export async function getUnreadCount(): Promise<{ count: number }> {
  return authorizedFetch<{ count: number }>("/notifications/unread-count");
}

export async function markNotificationAsRead(id: number): Promise<void> {
  await authorizedFetch<void>(`/notifications/${id}/read`, { method: "PATCH" });
}

export async function markAllNotificationsAsRead(): Promise<void> {
  await authorizedFetch<void>("/notifications/read-all", { method: "PATCH" });
}

export async function clearAllNotifications(): Promise<void> {
  await authorizedFetch<void>("/notifications", { method: "DELETE" });
}
